import React, { Component } from "react";
import styled from "styled-components";

import { Flex, Link, Button } from "../../components";
import { history } from "../../utils";
import ProgressBar from "../../components/ProgressBar";
import vars from "../../vars";
import Hexagon2 from "../../components/Hexagon2";
import Modal from "./Modal";
import MobileCarousel from '../../components/MobileCarousel/MobileCarousel';
import MQCard from '../../components/MQCard';
import MobileHeader from '../../components/MobileHeader';
import moment from 'moment';
import 'katex/dist/katex.min.css';
import LayoutWrapper from '../../components/LayoutWrapper';
import Equation from '../../components/Equation';
import {submitVptTest} from '../../lib/api';

const Box = styled.div`
  margin: 1em 0;
  padding: 1em;
  font-weight: bold;
  border-radius: 4px;
  background:white;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
`;

const Image = styled(Flex)`
  height: 15rem;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const Hint = styled(Flex)`
  padding: 1em 0;
  span,
  svg {
    color: ${vars.brand_color};
    padding: 0.5em;
  }
`;

const Options = styled.div`
  margin: 2rem 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 4em;
  align-items: stretch;
  @media (max-width: 768px) {
    grid-template-columns: auto;
    grid-gap: 1em;
  }
`;

const Option = styled(Flex)`
  padding: 1em 0.5em;
  border-radius: 0.5em;
  border: 1px solid #aaa;
  font-size: 1.2em;
  position: relative;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  background: ${({ blue, yellow }) =>
    blue ? "#42A5F5" : yellow ? "#eed94a" : "#fff"};
  cursor: pointer;
  transition: all .3s ease;
  
  &:hover {
    border-color: #ccc;
  }

  img {
    max-height: 5em;
  }
  div.qNo{
    position: absolute;
    left: 5px;
    top: 6px;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    text-align: center;
    background: #EEEEEE;
    font-size: 10px;
  }
  
  @media(max-width:767px){
    padding:8px;
  }
`;

const QuestionOverviewWrapper = styled.div`
  display:initial;
  @media (max-width: 767px) {
    display: none;
  }
`
const ActionButtons = styled.div`
  @media(max-width:767px){
    display:none;
  }
`

const GridLayout = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 2rem;
  @media (max-width: 768px) {
    grid-template-columns: auto;
  }
`;

const Hex = () => (
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 300 300">
    <polygon points="300,150 225,280 75,280 0,150 75,20 225,20" />
  </svg>
);

const Hexagon = styled(Flex)`
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 3em;
    height: 3em;
    cursor: pointer;
    text-decoration: none;
    span {
      color: #000;
      z-index: 1;
    }
  }

  svg {
    position: absolute;
    fill: ${({ blue, yellow }) =>
      blue ? "#42A5F5" : yellow ? "#eed94a" : "#ccc"};
    width: 100%;
    height: 100%;
    polygon {
      stroke: ${({ active }) => (active ? vars.brand_color : "transparent")};
      stroke-width: 10px;
      transition: all 0.3s esae;
    }
    transition: all 0.3s esae;
  }
`;

const QuestionsOverview = styled.div`
  display: grid;
  grid-template-columns: repeat(4, auto);
  grid-gap: 1em;
`;

class TestStart extends Component {
  state = {
    modalOpen: false,
    questionnaire_id: this.props.tid,
    question_answers: this.props.questions.map(({ id }) => ({
      question_id: id,
      question_option_id: null,
      timetaken: [],
      screenshot: 0,
      isBookMarked: false
    })),
    timelimit:this.props.timelimit,
    timeleft:this.props.timelimit,
    testSubmitting:false,
    testSubmittedFromMulitpleFraud:false,
    total_timetaken: 0,
    visitedTimeStamp:null,
    questionVisitDuration:0,
    offline:false,
    timerId:null,
    pageMounted:false,
    event:null,
    noOfWindowSwitches:0,
    dialogTitle:'Are you sure you want to submit the test ?'
  };

  componentDidMount=()=>{
    // let timeleft = localStorage.getItem('timeleft');
    // if(timeleft){
    //   this.setState({timelimit:parseInt(timeleft)});
    // }
    this.setState({pageMounted:true});
    window.addEventListener("online", ()=>{
      this.setState({offline:false});
    }, false);
    window.addEventListener("offline", ()=>{
      this.setState({offline:true});
    }, false);
    setTimeout(() => {
      this.askBeforeUserLeaving();
    }, 1000);
   
  }

  askBeforeUserLeaving(){
    try {
      let pathname,array = [];
      this.onVisibilityChange((visible) =>{
        if(!visible){
          this.setState({noOfWindowSwitches:this.state.noOfWindowSwitches+1});
          pathname =  window.location.pathname;
          array = pathname.split('/');
          if((array && array.length==4) || pathname=='/vpt/overview/' || pathname =='/vpt/thankyou' ){
            console.log( 'not inside test');
          }else {
            console.log( 'inside test');
            alert("warning:Your not allowed to change the window");
            if(this.state.noOfWindowSwitches >=2 ){
              if(this.state.testSubmittedFromMulitpleFraud)return;
              this.handleSubmit();
              this.setState({testSubmittedFromMulitpleFraud:true});
              clearInterval(this.state.timerId);
            };
            console.log("warning:Your not allowed to change the window");
          } 
        }
        console.log('the page is now', visible ? 'focused' : 'unfocused');
      });
    } catch (error) {
      console.log(error);
    }
    window.addEventListener("beforeunload", function (e) {
      var confirmationMessage = 'It looks like you have been editing something. '
                              + 'If you leave before saving, your changes will be lost.';

      (e || window.event).returnValue = confirmationMessage; //Gecko + IE
      return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
    });
  }

  onVisibilityChange(callback) {
    var visible = true;

    if (!callback) {
        throw new Error('no callback given');
    }

    function focused() {
        if (!visible) {
            callback(visible = true);
        }
    }

    function unfocused() {
        if (visible) {
            callback(visible = false);
        }
    }

    // Standards:
    if ('hidden' in document) {
        document.addEventListener('visibilitychange',
            function() {(document.hidden ? unfocused : focused)()});
    }
    if ('mozHidden' in document) {
        document.addEventListener('mozvisibilitychange', function() {
          (document.mozHidden ? unfocused : focused)()
        });
    }
    if ('webkitHidden' in document) {
        document.addEventListener('webkitvisibilitychange',
            function() {(document.webkitHidden ? unfocused : focused)()});
    }
    if ('msHidden' in document) {
        document.addEventListener('msvisibilitychange',
            function() {(document.msHidden ? unfocused : focused)()});
    }
    // IE 9 and lower:
    if ('onfocusin' in document) {
        document.onfocusin = focused;
        document.onfocusout = unfocused;
    }
    // All others:
    window.onpageshow = window.onfocus = focused;
    window.onpagehide = window.onblur = unfocused;
};
  
  updateScrollStates(prevQid,activeQId,event){
    try {
      if(!event || !event.pageX) return;
      let width = window.innerWidth;
      let center = width/2;
      let difference =event.pageX - center;
      let scrollbleElement = document.getElementById('mobile-scroller');
      scrollbleElement.scrollBy({
        left: difference,
        behavior: 'smooth'
      });
      localStorage.setItem('lastX',event.pageX);
      localStorage.setItem('lastScrollLeftPosition',scrollbleElement.scrollLeft);
    } catch (error) {
      alert(error);
    }
  }


  
  onQuestionClick(qid,i,event){
    try {
      this.updateScrollStates(qid,i,event);
      let datetime = moment().format('YYYY-MM-DD hh:mm:ss:SSS').toString();
      let { tid, questions } = this.props;
      this.setState(prevState => {
        let question = prevState.question_answers.find(
          ({ question_id }) => question_id === questions[qid].id
        );
        let timetaken;
        var a = moment(datetime, "yyyy-MM-dd HH:mm:ss.SSS").toDate();
        var b = moment(prevState.visitedTimeStamp, "yyyy-MM-dd HH:mm:ss.SSS").toDate();
        let questionVisitDuration = (a-b)/1000;
        if(typeof(question.timetaken) =="string") timetaken = JSON.parse(question.timetaken);
        else timetaken = question.timetaken;
        if(timetaken.length >0){
          timetaken.push([prevState.visitedTimeStamp,datetime,questionVisitDuration]);
        }else {
          timetaken = [[prevState.visitedTimeStamp,datetime,questionVisitDuration]];
        }
        question.timetaken = timetaken;
        return prevState;
      });
      this.setState(prevState => {
        prevState.visitedTimeStamp=datetime;
        prevState.questionVisitDuration =0;
        return prevState;
      });
    } catch (error) {
      console.log(error);
    }
  }

  checkNative=()=>{
    try {
      if((window.webkit) || window.appInterface)
      return true;
      else return false;
    } catch (error) {
      console.log(error);
    }
  }

  componentWillMount(){
    try {
      localStorage.removeItem('lastX');
      localStorage.removeItem('lastScrollLeftPosition');
    } catch (error) {
      console.log(error);
    }
  }

  handleSubmit = async () => {
    try {
      if(this.state.offline){
        this.setState({modalOpen:true,dialogTitle:'No internet connection'});
        return;
      }
      clearInterval(this.state.timerId);
      if(this.state.testSubmitting) return;
      this.setState({testSubmitting:true});
      let { tid,qid } = this.props;
      this.onQuestionClick(qid);
      console.log('beofre submitting',this.state);
      let response = await submitVptTest({ ...this.state });
      console.log(response);
      this.setState({testSubmitting:false});
      if (response.status==200) {
        console.log('successfull response');
          localStorage.removeItem('lastX');
          localStorage.removeItem('lastScrollLeftPosition');
          // localStorage.setItem('user',response.user);
          history.push(`/vpt/thankyou?user=${response.user}`);
      } else if(response.status==204) {
        console.log('test already taken response',response);
        alert("Test already submitted!");
      }else {
        console.log('other response',response);
        alert("Something wrong from server side");
      }
    } catch (error) {
      if(this.state.offline){
        this.setState({
          dialogTitle:'Your not connected to active internet.',
          modalOpen:true
        });
      }
      this.setState({testSubmitting:false});
    }
  };

  handleModalToggle = () => {
    if(this.state.modalOpen){
      this.setState({ modalOpen: false});
      return;
    }
    if(this.state.offline){
      this.setState({
        dialogTitle:'Your not connected to active internet.',
        modalOpen:true
      });
      return;
    }else {
      this.setState({ modalOpen: true,dialogTitle:'Are you sure you want to submit the test ?' });
    }
  };

  handleBookMark = () => {
    let { tid, qid, questions } = this.props;
    this.setState(prevState => {
      let question = prevState.question_answers.find(
        ({ question_id }) => question_id === questions[qid].id
      );
      question.question_option_id = null;
      question.isBookMarked = true;
      return prevState;
    });
  };

  updateTimers=(timerId,timeleft)=>{
    this.setState(prevState => {
      let datetime = moment().format('YYYY-MM-DD hh:mm:ss:SSS').toString();
      if(!prevState.visitedTimeStamp){
        prevState.visitedTimeStamp = datetime
      };
      prevState.total_timetaken = prevState.total_timetaken+1;
      prevState.questionVisitDuration = prevState.questionVisitDuration+1;
      prevState.timerId = timerId;
      return prevState;
    });
  }

  handleCheck = (id,is_answer) => {
    let { tid, qid, questions } = this.props;
    this.setState(prevState => {
      let question = prevState.question_answers.find(
        ({ question_id }) => question_id === questions[qid].id
      );
      question.question_option_id = id;
      question.isBookMarked = false;
      question.is_answer =is_answer;
      return prevState;
    });
  };

  constructor(props) {
    super(props); 
  }



  render() {

    let { tid, qid, questions } = this.props;
    let { question_answers, modalOpen,timelimit } = this.state;
    if (!questions || !questions.length) {
      return <p>No questions</p>;
    }
    if(!this.state.pageMounted)return <p>Loading</p>;
    let pattern = /\$.*?\$/gm;
    
    return (
      <>
       <div style={{position:'fixed',width:'100%', height:'100px',boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',zIndex:'2',background:'white',top:0}}>
         <div style={{padding:'15px'}}>
          <Flex direction="row" >
            <div style={{width:'50px', cursor:'pointer'}}>
              <img onClick={this.handleModalToggle} src="/images/back.svg"></img>
            </div>
            <div style={{width:'calc(100% - 50px)'}} >
              <ProgressBar updateTimers={this.updateTimers} timelimit={timelimit} handleTimeout={this.handleSubmit} />
            </div>
          </Flex >
          <MobileHeader blooms={questions[qid].blooms_level} qNo={(1+parseInt(qid))} length={questions.length} onClick={this.handleModalToggle} btnTitle="Submit"></MobileHeader> 
         </div>
        </div>  
         <LayoutWrapper>
       
        <GridLayout>
         
          <Flex column>
            <Box><Equation math_type={1} bold equation={questions[qid].name}></Equation></Box>
            {questions[qid].media === 1 && (
              <Image center>
                <img src={questions[qid].question_img} alt="" />
              </Image>
            )}
            <Hint alignCenter justifyEnd>
              {/* <Link to={"/"}>
                <span>View hint</span>
              </Link> */}
              <div style={{ cursor: "pointer" }} onClick={this.handleBookMark}>
               <span>{question_answers[qid].isBookMarked ?'Bookmarked' :'Bookmark' }</span>
              </div>
            </Hint>
            <Options>
              {questions[qid].question_options.map(
                ({ id, name, media, option_img,is_answer }, i) => (
                  <Option
                    key={i}
                    i={i}
                    center
                    column
                    wrap="true"
                    onClick={() => this.handleCheck(id,is_answer)}
                    blue={Boolean(
question_answers[qid].question_option_id === id
                    )}
                  >
                    <div className="qNo"><p>{i+1}</p></div>
                    <div style={{paddingLeft:'30px',paddingRight:'20px'}}>
                      <Equation math_type={1}  equation={name}></Equation>
                      {media === 1 && <img src={option_img} alt="" />}
                    </div>
                    
                    
                  </Option>
                )
              )}
            </Options>
            {qid == questions.length-1 &&
              <Flex justifyEnd>
                  <Button disabled={this.state.testSubmitting} onClick={this.handleModalToggle}>Submit</Button>
              </Flex> 
            }
            
            <ActionButtons>
              <Flex justifyBetween>
                {qid > 0 ? (
                  <Link to={`/vpt/test/${tid}/${parseFloat(qid) - 1}`}>
                    <Button onClick={()=>this.onQuestionClick(qid)}>Previous</Button>
                  </Link>
                ) : (
                  <div />
                )}
                {questions.length - 1 > qid ? (
                  <Link to={`/vpt/test/${tid}/${parseFloat(qid) + 1}`}>
                    <Button onClick={()=>this.onQuestionClick(qid)}>Next</Button>
                  </Link>
                ) : (
                  <div />
                )}
              </Flex>
            </ActionButtons>
            
          </Flex>

          <QuestionOverviewWrapper>
          <Flex column>
            <Box simple>
              <h3>Questions overview</h3>
              <QuestionsOverview>
                {questions.map(({ id }, i) => (
                  <Hexagon
                    key={id}
                    center
                    active={!(i - qid)}
                    blue={Boolean(question_answers[i].question_option_id)}
                    yellow={Boolean(question_answers[i].isBookMarked)}
                    onClick={()=>this.onQuestionClick(qid)}
                  >
                    <Link to={`/vpt/test/${tid}/${i}`}>
                      <Hex />
                      <span>{i + 1}</span>
                    </Link>
                  </Hexagon>
                ))}
              </QuestionsOverview>
              <Flex center style={{ marginTop: "2em" }}>
                <Button onClick={this.handleModalToggle}>Submit</Button>
              </Flex>
              <div style={{ marginTop: "2em" }}>
                {[
                  { title: "Active Question", active: true },
                  { title: "Answered", color: "blue" },
                  { title: "Bookmarked", color: "yellow" },
                  { title: "Unanswered", color: "" }
                ].map(({ active, color, title }) => (
                  <div key={title}>
                    <Flex alignCenter>
                      <Hexagon
                        active={active}
                        yellow={color == "yellow" ? true : false}
                        blue={color == "blue" ? true : false}
                      >
                        <a>
                          <Hex />
                        </a>
                      </Hexagon>
                      <p style={{ marginLeft: "1em" }}>{title}</p>
                    </Flex>
                  </div>
                ))}
              </div>
            </Box>
            <div className="prvc1">
              <span><a href="https://www.edwisely.com/privacy.html" target="_blank">Privacy policy </a> &nbsp;&nbsp;&nbsp;&nbsp;
              <a href="https://www.edwisely.com/tos.html" target="_blank">Terms &amp; Conditions</a></span><br/>
            </div>
            <div style={{textAlign:'center',marginTop:'-10px'}}>
              <span style={{color:'#000000',fontSize: '14px'}}>All Rights Reserved. © 2019  Edwisely. Copyright of Hakate Technologies Pvt. LTD</span>
            </div>  
            <style jsx="true">{`
              .prvc1{
                margin-top:20px;
                margin-bottom: 30px;    
                text-align:center;
              }
              .prvc span a{
                text-decoration:underline;
                font-size: 12px;
              }
              @media(max-width:767px){
                display:none;
              }
            `}
            </style> 
          </Flex>
          
          </QuestionOverviewWrapper>
              
        </GridLayout>
       


        <Modal
          open={modalOpen}
          handleModalToggle={this.handleModalToggle}
          handleSubmit={this.handleSubmit}
          dialogTitle={this.state.dialogTitle}
        />
        </LayoutWrapper>
        <MobileCarousel activeQId={qid}>

{questions.map(({ id,name }, i) => (
            //Handle mobile click
            <Link to={`/vpt/test/${tid}/${i}`} key={i}>
            <MQCard onClick={(event)=>this.onQuestionClick(qid,i,event)} active={i==qid ? true : false}>
                <Hexagon2
                blue={Boolean(question_answers[i].question_option_id)}
                
                yellow={Boolean(question_answers[i].isBookMarked)}
                qNo={i+1}></Hexagon2>
                <span>  
        <Equation math_type={1} equation={name.slice(0,8)+'...'}></Equation>
              </span>
              </MQCard>
            </Link>
        ))}
</MobileCarousel>

      </>
    );
  }
}

export default TestStart;
